// Digest: c8adef1e35146a6a5cc6f44e73ee96734c2eabe4
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type Id = string;
export type Disabled = boolean;
export type Required = boolean;
export type Placeholder = string;
export type Even = boolean;
export type TemplateName = string;
export type Path = string;
export type Url = string;
export type CspNonce = string | null;
export type Id1 = number | string | null;
export type Username = string;
export type IsAuthenticated = boolean;
export type IsStaff = boolean;
export type LevelTag = "info" | "success" | "error" | "warning" | "debug";
export type Message1 = string;
export type Level = number;
export type FromServer = boolean;
export type Messages = Message[];
export type CsrfToken = string;
export type MobileOs = ("android" | "ios") | null;
export type UrlName = string | null;
export type StaticUrl = string;
export type Realm = "site" | "app";
export type SentryDsn = string;
export type MixpanelToken = string;
export type AnalyticsId = string;
export type StaticUrl1 = string;
export type MediaUrl = string;
export type Name = string;
export type Waist = string | null;
export type BodyFat = string | null;
export type HasHiddenMacros = boolean;
export type UseKilojoules = boolean;
export type IsImperial = boolean;
export type Activity = string | null;
export type Goal = number | null;
export type Gender = string | null;
export type DateOfBirth = string | null;
export type Height = string | null;
export type Weight = string | null;
export type EntriesCreated = number;
export type WorkoutsCompleted = number;
export type Id2 = number;
export type DateJoined = string;
export type ManagerName = string | null;
export type Email = string;
export type HasBetaAccess = boolean;
export type TrackingKey = string;
export type ShouldCollectAnalytics = boolean;
export type Id3 = number;
export type Name1 = string;
export type Context_Type = "LOG" | "BASIC" | "ADVANCED";
export type CaloriesTarget = string | null;
export type ProteinTarget = string | null;
export type FatTarget = string | null;
export type CarbsTarget = string | null;
export type FiberTarget = string | null;
export type NetCarbsTarget = string | null;
export type MealPlanId = number | null;
export type Targets = ClassDc93A75E1893A2E3B0De0Ee7151Ce111[];
export type IsSubscriptionActive = boolean;
export type IsReportsEnabled = boolean;
export type IsTrialActive = boolean;
export type IsClient = boolean;
export type IsManager = boolean;
export type HasPeptides = boolean;
export type HasWalkingClub = boolean;
export type Context_Announcement =
  | "HIDDEN_MACROS"
  | "SWIPE_TO_GO_BACK"
  | "MEAL_PLANS_BETA"
  | "CLIENT_MEASUREMENTS"
  | "COPY_MEAL_PLANS"
  | "MIGRATE_FROM_MYFITNESSPAL"
  | "SHOW_MIGRATE_FROM_MYFITNESS_PAL"
  | "FITNESS_BETA"
  | "MANAGER_FITNESS_BETA"
  | "WORKOUT_TEMPLATES"
  | "APPLE_HEALTH"
  | "NUTRITIONAL_AI"
  | "AI_COHORT"
  | "MODAL_ENTRY"
  | "CHALLENGE"
  | "HAS_USED_MYFITNESSPAL"
  | "NUTRITIONAL_VISION_INSTRUCTIONS"
  | "METHOD"
  | "NUTRITIONAL_AUDIO_INSTRUCTIONS"
  | "FIXED_SYNC_BUTTON"
  | "IAP_TRIAL"
  | "ENTRY_INSTRUCTIONS"
  | "SHARED_RECIPES"
  | "SHOW_INSTAGRAM_PROMPT"
  | "SHOW_REQUEST_TRACKING_AUTHORIZATION"
  | "SHOW_RECIPE_REGISTRATION"
  | "HIDE_RECIPE_REGISTRATION"
  | "DEBUG_HEALTHKIT"
  | "HAS_VIDEO_ACCESS"
  | "DEMO_MODE"
  | "PREDICTIONS"
  | "HOTJAR"
  | "PREDICTIONS_V2"
  | "LEARNING_WEEK"
  | "LEARNING_WEEK_TOUR"
  | "PLAN_WAITLIST"
  | "CAMERA_SEARCH_TUTORIAL"
  | "NEEDS_APPLE_HEALTH_RESYNC"
  | "RESYNCED_APPLE_HEALTH"
  | "WALKING_CLUB";
export type CastedDismissedAnnouncements = Context_Announcement[];
export type GetMeasurements = (
  | "weight"
  | "waist"
  | "navel"
  | "body_fat"
  | "hips"
  | "neck"
  | "thigh"
  | "bicep"
  | "chest"
)[];
export type ManagerFullName = string;
export type ManagerSlug = string;
export type RegistrationRecipeName = string | null;
export type MustVerifyEmail = boolean;
export type Context_CheckIn = "DISABLED" | "ENABLED";
export type TargetId = number | null;
export type DayOfWeek = number;
export type DayTemplateId = number | null;
export type Id4 = number;
export type Assignments = ClassE686Da6Bf39Ca0B52D6578Ee92015C98[];
export type Askedforrating = boolean;
export type AppleHealth = Postponed | Never | Enabled | ShouldRequest;
export type Status = "LATER";
export type PostponedUntil = string;
export type Postponements = number;
export type EntriesCreated1 = number;
export type WorkoutsCompleted1 = number;
export type Status1 = "NEVER";
export type Status2 = "ENABLED";
export type Status3 = "SHOULD_REQUEST";
export type PushNotifications = Postponed | Never | Enabled;
export type TrackingAuthorization = "authorized" | "denied" | "notDetermined" | "restricted";
export type Myfitnesspal = (Postponed | Never | Enabled) | null;
export type Onboarding = (Postponed | Never | Enabled) | null;
export type Meals = ("MANUAL" | "AUTO_CREATED") | null;
export type RatingRequest = (Postponed | Enabled) | null;
export type FollowOnInstagram = (Postponed | Never | Enabled) | null;
export type ShareUuid = string;
export type TrackingKey1 = string;
export type Id5 = number;
export type Name2 = string;
export type Id6 = number;
export type Email1 = string;
export type Clients = ServerCoreContextProcessors_ClientManagerContextOutput[];

export interface _Types {
  globals: {
    Widget:
      | ServerCoreFormsIntegerInput
      | ServerCoreFormsEnergyInput
      | ServerCoreFormsWeightInput
      | ServerCoreFormsPercentInput
      | ServerCoreFormsLengthInput
      | ServerCoreFormsDistanceInput
      | ServerCoreFormsWeightMultiplierInput
      | ServerCoreFormsRangeInput
      | ServerCoreFormsMarkdownArea
      | ServerCoreFormsQuickSelect
      | TaggitFormsTagWidget
      | DjangoFormsWidgetsEmailInput
      | DjangoFormsWidgetsTextInput
      | DjangoFormsWidgetsCheckboxInput
      | DjangoFormsWidgetsURLInput
      | DjangoFormsWidgetsSelect
      | DjangoFormsWidgetsHiddenInput
      | DjangoFormsWidgetsClearableFileInput
      | DjangoFormsWidgetsDateTimeInput
      | ServerManagerFormsSelectBirthDate
      | DjangoFormsWidgetsDateInput
      | DjangoFormsWidgetsTextarea
      | DjangoFormsWidgetsPasswordInput
      | DjangoFormsWidgetsNumberInput;
    models: null;
  };
  Context: Context;
  RPCPermission: null;
}
export interface ServerCoreFormsIntegerInput {
  template_name: "integer";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.IntegerInput";
}
export interface ReactivatedFormsWidgetsStepAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsEnergyInput {
  template_name: "energy";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.EnergyInput";
}
export interface ServerCoreFormsWeightInput {
  template_name: "weight";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.WeightInput";
}
export interface ServerCoreFormsPercentInput {
  template_name: "percent";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.PercentInput";
}
export interface ServerCoreFormsLengthInput {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ServerCoreFormsDistanceInput {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.DistanceInput";
}
export interface ServerCoreFormsWeightMultiplierInput {
  template_name: "multiplier";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.WeightMultiplierInput";
}
export interface ServerCoreFormsRangeInput {
  template_name: "range";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.RangeInput";
}
export interface ServerCoreFormsMarkdownArea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsTextareaAttrs;
  tag: "server.core.forms.MarkdownArea";
}
export interface ReactivatedFormsWidgetsTextareaAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface ServerCoreFormsQuickSelect {
  template_name: "quick";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: QuickSelectAttrs;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember], number][];
  tag: "server.core.forms.QuickSelect";
}
export interface QuickSelectAttrs {
  id: Id;
  disabled?: Disabled;
  required?: Required;
  placeholder?: Placeholder;
  even: Even;
}
export interface ReactivatedFormsWidgetsOptgroupMember {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface TaggitFormsTagWidget {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs;
  type: "text";
  tag: "taggit.forms.TagWidget";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsEmailInput {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface DjangoFormsWidgetsCheckboxInput {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsURLInput {
  template_name: "django/forms/widgets/url.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs;
  type: "url";
  tag: "django.forms.widgets.URLInput";
}
export interface DjangoFormsWidgetsSelect {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember], number][];
  tag: "django.forms.widgets.Select";
}
export interface DjangoFormsWidgetsHiddenInput {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface DjangoFormsWidgetsClearableFileInput {
  template_name: "django/forms/widgets/clearable_file_input.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs;
  type: "file";
  checkbox_name: string;
  checkbox_id: string;
  is_initial: boolean;
  input_text: string;
  initial_text: string;
  clear_checkbox_label: string;
  tag: "django.forms.widgets.ClearableFileInput";
}
export interface DjangoFormsWidgetsDateTimeInput {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface ServerManagerFormsSelectBirthDate {
  template_name: "django/forms/widgets/select_date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: unknown;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs;
  _reactivated_value_do_not_use?: {
    year: string | null;
    month: string | null;
    day: string | null;
  };
  /**
   * @minItems 3
   * @maxItems 3
   */
  subwidgets: [DjangoFormsWidgetsSelect, DjangoFormsWidgetsSelect, DjangoFormsWidgetsSelect];
  tag: "server.manager.forms.SelectBirthDate";
}
export interface DjangoFormsWidgetsDateInput {
  template_name: "django/forms/widgets/date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateAttrs;
  type: "text";
  tag: "django.forms.widgets.DateInput";
}
export interface ReactivatedFormsWidgetsDateAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format?: string;
}
export interface DjangoFormsWidgetsTextarea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsTextareaAttrs;
  tag: "django.forms.widgets.Textarea";
}
export interface DjangoFormsWidgetsPasswordInput {
  template_name: "django/forms/widgets/password.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs;
  type: "password";
  tag: "django.forms.widgets.PasswordInput";
}
export interface DjangoFormsWidgetsNumberInput {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface Context {
  template_name: TemplateName;
  request: Request;
  user: SafeUser | null;
  messages: Messages;
  csrf_token: CsrfToken;
  mobile_os: MobileOs;
  view: View;
  STATIC_URL: StaticUrl;
  realm: Realm;
  environment: Settings;
  profile: ServerCoreRpc_ProfileOutput | null;
  lead: ServerCoreContextProcessors_LeadOutput | null;
  clients: Clients;
}
export interface Request {
  path: Path;
  url: Url;
  csp_nonce: CspNonce;
}
/**
 * The safe default shape for ``django.contrib.auth``'s context
 * processor: the user's own identity, nothing more. No email (keep PII
 * out of rendered props by default), no perms (PermWrapper is a lazy,
 * query-bearing proxy). Override by registering a replacement Pick via
 * ``register_processor_type`` — or skip Django's processor and write
 * your own, which supersedes this entirely.
 */
export interface SafeUser {
  id: Id1;
  username: Username;
  is_authenticated: IsAuthenticated;
  is_staff: IsStaff;
}
export interface Message {
  level_tag: LevelTag;
  message: Message1;
  level: Level;
  from_server?: FromServer;
}
export interface View {
  url_name: UrlName;
}
export interface Settings {
  SENTRY_DSN: SentryDsn;
  MIXPANEL_TOKEN: MixpanelToken;
  ANALYTICS_ID: AnalyticsId;
  STATIC_URL: StaticUrl1;
  MEDIA_URL: MediaUrl;
}
export interface ServerCoreRpc_ProfileOutput {
  name: Name;
  waist: Waist;
  body_fat: BodyFat;
  has_hidden_macros: HasHiddenMacros;
  use_kilojoules: UseKilojoules;
  is_imperial: IsImperial;
  activity: Activity;
  goal: Goal;
  gender: Gender;
  date_of_birth: DateOfBirth;
  height: Height;
  weight: Weight;
  entries_created: EntriesCreated;
  workouts_completed: WorkoutsCompleted;
  user: Class_9E460C5B23A2310C95Ff6E8F9778F0F9;
  assignments: Assignments;
  settings: Settings1;
  share_uuid: ShareUuid;
}
export interface Class_9E460C5B23A2310C95Ff6E8F9778F0F9 {
  id: Id2;
  date_joined: DateJoined;
  manager_name: ManagerName;
  email: Email;
  has_beta_access: HasBetaAccess;
  tracking_key: TrackingKey;
  should_collect_analytics: ShouldCollectAnalytics;
  targets: Targets;
  is_subscription_active: IsSubscriptionActive;
  is_reports_enabled: IsReportsEnabled;
  is_trial_active: IsTrialActive;
  is_client: IsClient;
  is_manager: IsManager;
  has_peptides: HasPeptides;
  has_walking_club: HasWalkingClub;
  casted_dismissed_announcements: CastedDismissedAnnouncements;
  get_measurements: GetMeasurements;
  manager_full_name: ManagerFullName;
  manager_slug: ManagerSlug;
  registration_recipe_name: RegistrationRecipeName;
  must_verify_email: MustVerifyEmail;
}
export interface ClassDc93A75E1893A2E3B0De0Ee7151Ce111 {
  id: Id3;
  name: Name1;
  type: Context_Type;
  calories_target: CaloriesTarget;
  protein_target: ProteinTarget;
  fat_target: FatTarget;
  carbs_target: CarbsTarget;
  fiber_target: FiberTarget;
  net_carbs_target: NetCarbsTarget;
  meal_plan_id: MealPlanId;
}
export interface ClassE686Da6Bf39Ca0B52D6578Ee92015C98 {
  check_in: Context_CheckIn;
  target_id: TargetId;
  day_of_week: DayOfWeek;
  day_template_id: DayTemplateId;
  id: Id4;
}
export interface Settings1 {
  askedForRating?: Askedforrating;
  by_device?: ByDevice;
  myfitnesspal?: Myfitnesspal;
  onboarding?: Onboarding;
  meals?: Meals;
  rating_request?: RatingRequest;
  follow_on_instagram?: FollowOnInstagram;
}
export interface ByDevice {
  [k: string]: DeviceSettings | null;
}
export interface DeviceSettings {
  apple_health?: AppleHealth;
  push_notifications?: PushNotifications;
  tracking_authorization?: TrackingAuthorization;
}
export interface Postponed {
  status: Status;
  postponed_until: PostponedUntil;
  postponements: Postponements;
  entries_created?: EntriesCreated1;
  workouts_completed?: WorkoutsCompleted1;
}
export interface Never {
  status: Status1;
}
export interface Enabled {
  status: Status2;
}
export interface ShouldRequest {
  status: Status3;
}
export interface ServerCoreContextProcessors_LeadOutput {
  tracking_key: TrackingKey1;
}
export interface ServerCoreContextProcessors_ClientManagerContextOutput {
  id: Id5;
  name: Name2;
  client: Class_5D04Be4F56D037E53627D3704Afa3Bc2;
}
export interface Class_5D04Be4F56D037E53627D3704Afa3Bc2 {
  id: Id6;
  email: Email1;
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {ReactivateConfig as GenericReactivateConfig} from "reactivated/dist/client";
export type ReactivateConfig = GenericReactivateConfig<_Types["Context"]>;
export declare const reactivate: (config?: ReactivateConfig) => void;
export declare const reactivateAdmin: () => void;

export const rpc = {requester: typeof window != "undefined" ? rpcUtils.defaultRequester : null as any};
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export {Context} from "./context";
import {Context} from "./context";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};


export * as forms from "./forms";


export * from "./schema";
